import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { withRouter, } from "react-router";
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import IfGranted from '../views/auth/IfGranted';
import MainListItem from './MainListItem';
import navigationConfig from '../main/navigationConfig';
import { withRemoteConfig } from '../state/remoteConfig/RemoteConfigContext';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100hv'
  },
  divider: {
    margin: `0 ${theme.spacing(3)}px`
  },
  nested: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(4)
    },
    [theme.breakpoints.only('xs')]: {
      paddingLeft: theme.spacing(3)
    }
  },
});
class MainListItems extends Component {

  goToRoute = (route) => {
    this.props.history.push(`${route}`)
  };


  render() {
    const { classes, location, remoteConfig } = this.props;
    const { isMenuEnabled } = remoteConfig || {};

    const isActive = (url) => {
      return location.pathname.includes(url) ? 'is-active' : '';
    }

    const menus = isMenuEnabled
      ? navigationConfig.filter(nav => isMenuEnabled(nav.id))
      : navigationConfig;

    return (
      <div className={classes.root}>
        {
          menus.length > 0 &&
          menus.map((nav, index) => {
            return (
              <Fragment key={nav.id}>
                <IfGranted>
                  <MainListItem
                    nav={nav}
                    isActive={isActive}
                    goToRoute={this.goToRoute}
                  />
                </IfGranted>
                {
                  (index !== (menus.length - 1) &&
                    <Divider className={classes.divider} />)
                }
              </Fragment>
            )
          })
        }
      </div>
    );
  }
}

export default compose(withRouter, withStyles(styles), withRemoteConfig)(MainListItems);
